<template>
  <div class="banner_box">
    <swiper
      :options="swiperOptions"
      :key="swiperKey"
      v-if='items.length>0'
    >
      <swiper-slide 
        v-for="(item,index) in items" 
        :key="index"
      >
        <div class="banner_item" @click="handleClick(item)">         
          <img 
            :src="item.imgUrl[0].urlHttps"
            v-http2
            v-img-size="'medium'"
            v-img-error
            alt="" />
        </div>
      </swiper-slide>
      <div class="swiper-pagination banner_pagination" slot="pagination"></div>
      <div
        v-if="!isH5 && items.length>1"
        class="banner-prev-banner-invite icon-linetype_back_iOS"
        slot="button-prev">
      </div>
      <div
        v-if="!isH5 && items.length>1"
        class="banner-next-banner-invite icon-outline_entrance"
        slot="button-next">
      </div>
    </swiper>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'InviteBanner',
  props: {
    items: {
      type: Array,
      required: true,
      default: ()=> [],
    },
  },
  computed: {
    ...mapState('common', ['isH5']),
    swiperOptions() {
      return {
        loop : true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        observer: true,
        observeParents: true,
        pagination: {
          el: '.banner_pagination',
        },
        navigation: {
          nextEl: '.banner-next-banner-invite',
          prevEl: '.banner-prev-banner-invite'
        },
      }
    },
  },
  watch: {
    swiperOptions() {
      this.swiperKey = this.swiperKey + 1
    },
  },
  data() {
    return {
      swiperKey: 1
    }
  },
}
</script>

<style lang="scss" scoped>
.banner_box ::v-deep .swiper-pagination-bullet {
  width: 12px;
  height: 2px;
  opacity: 0.3;
  background: #FFFFFF;
  border-radius: 1px;
}
.banner_box ::v-deep .swiper-pagination-bullet-active {
  opacity: 0.66;
  background: #FFFFFF;
}
.banner_box {
  width: 100%;
  margin: 0 auto;
  display: flex;
  position: relative;
  .banner_item {
    width: 470px;
    height: 270px;
    // cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.banner-prev-banner-invite {
  display: flex;
  position: absolute;
  top: 56%;
  left: 24px;
  z-index: 2;
  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
  align-items:center;
  justify-content:center;
  width: 28px;
  height: 28px;
  font-size: 13px;
  color: #000;
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
}

.banner-next-banner-invite {
  font-size: 13px;
  background-color: #fff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  right: 24px;
  top: 56%;
  z-index: 2;
  position:absolute;
  cursor:pointer;
  display: flex;
  color: #000;
  align-items:center;
  justify-content:center;
  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
}
@media (max-width: 768px) {
  .banner_box ::v-deep .swiper-pagination-bullet {
    width: rem(20);
    height: rem(4);
    opacity: 0.3;
    background: #FFFFFF;
    border-radius: rem(16);
  }
  .banner_box ::v-deep .swiper-pagination-bullet-active {
    opacity: 0.66;
    background: #FFFFFF;
  }
  .banner_box {
    .banner_item {
      width: 100vw;
      height: rem(430);
    }
  }
}
</style>